import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import useChangeCheck from "./useChangeCheck";
import ChangeCheckContext from "../support/ChangeCheckContext";
import CodeMirror from "@uiw/react-codemirror";
import { css } from '@codemirror/lang-css';
import { color } from '@uiw/codemirror-extensions-color';

function BooleanInput(props) {

    const {disable} = React.useContext(ChangeCheckContext)
    const { onChange, getStyle } = useChangeCheck(props.onChange);

    function customOnChange(newValue) {
        onChange({target: {name: props.name, value: newValue}})
    }

    return (
        <>
            {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
            <CodeMirror editable={!disable} value={props.value} height="200px" extensions={[css(), color]} onChange={customOnChange}/>
        </>
    )
}

export default BooleanInput
